package at.theatervogelweide.admin.web.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.compositionLocalOf
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.ContentBuilder
import org.w3c.dom.HTMLAnchorElement

/**
 * The public site of the same environment, from the server's configuration (#64): one web bundle serves staging and
 * production, so it can't know the address itself.
 */
class PublicSite(baseUrl: String) {
    private val base = baseUrl.trimEnd('/')

    /** [path] on the public site, e.g. `/tickets`. */
    fun url(path: String = "/"): String = base + path
}

/** `null` until the server said which public site belongs to it. */
val LocalPublicSite = compositionLocalOf<PublicSite?> { null }

/**
 * The new public site of the same environment (beta) until the switch-over (#144), which removes it (#115): `null`
 * until the server said which one belongs to it, and while `ADMIN_BETA_SITE_URL` isn't set.
 */
val LocalBetaSite = compositionLocalOf<PublicSite?> { null }

/** Opens [path] of the public site in a new tab; left out until the address is known. */
@Composable
fun PublicSiteLink(path: String, vararg classNames: String, content: ContentBuilder<HTMLAnchorElement>) {
    SiteLink(LocalPublicSite.current ?: return, path, classNames, content)
}

/** Opens the beta site's start page in a new tab; left out while its address is unknown or not configured (#144). */
@Composable
fun BetaSiteLink(content: ContentBuilder<HTMLAnchorElement>) {
    SiteLink(LocalBetaSite.current ?: return, "/", emptyArray(), content)
}

@Composable
private fun SiteLink(site: PublicSite, path: String, classNames: Array<out String>, content: ContentBuilder<HTMLAnchorElement>) {
    A(site.url(path), {
        if (classNames.isNotEmpty()) {
            classes(*classNames)
        }
        attr("target", "_blank")
        attr("rel", "noopener")
    }, content)
}
